import { useEffect, useCallback, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid, Button, TextField } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import DeleteIcon from "@mui/icons-material/Delete";
import BackButton from "components/shared/BackButton";
import { StyledStack, StyledTitle, ButtonContainer } from "./Add.style";
import DrawerCM from "components/shared/Drawer";
import Toast from "helper/toast";
import LoadingCM from "components/shared/Loading";
import useHttp from "hooks/use-http";
import {
  getQuestionInfoRequest,
  updateQuestionRequest,
  deleteQuestionRequest,
} from "api/requests";
import { commonQuestionSchema } from "validations";
import DeleteModal from "components/shared/Modal/Delete";

export default function EditQuestion() {
  const navigate = useNavigate();
  const params = useParams();
  const { request, loading } = useHttp();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(commonQuestionSchema),
  });
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handelShowModal = () => setShowDeleteModal((state) => !state);

  const onSubmit = async (values) => {
    values.id = params.questionId;

    const res = await request({
      url: updateQuestionRequest,
      values,
    });

    if (res) {
      Toast({
        type: "success",
        title: "ویرایش سوال",
      });
    }
    // navigate("/question");
  };

  const handelDelete = async () => {
    const res = await request({
      url: deleteQuestionRequest,
      values: params.questionId,
    });
    if (res) Toast({ type: "success", title: "حذف" });
    navigate("/question");
  };

  const getQuestionInfo = useCallback(async () => {
    let res = await request({
      url: () => getQuestionInfoRequest(params.questionId),
    });

    if (res) {
      reset({
        question: res.question,
        answer: res.answer,
      });
    }
  }, [request, params.questionId, reset]);

  useEffect(() => {
    getQuestionInfo();
  }, [getQuestionInfo]);

  return (
    <DrawerCM title="ویرایش سوال">
      {loading ? (
        <LoadingCM />
      ) : (
        <Grid container my={2}>
          <Grid item mt={3} xs={12}>
            <BackButton />
          </Grid>
          <StyledStack>
            <StyledTitle>ویرایش سوال</StyledTitle>
            <Grid container>
              <Grid item xs={12} p={1.2}>
                <TextField
                  id="question"
                  label="پرسش"
                  variant="outlined"
                  multiline
                  rows={2}
                  fullWidth
                  required
                  {...register("question")}
                  error={Boolean(errors.question)}
                  helpertext={errors.question?.message}
                />
              </Grid>
              <Grid item xs={12} p={1.2}>
                <TextField
                  id="answer"
                  label="پاسخ"
                  variant="outlined"
                  multiline
                  rows={2}
                  fullWidth
                  required
                  {...register("answer")}
                  error={Boolean(errors.answer)}
                  helpertext={errors.answer?.message}
                />
              </Grid>

              <ButtonContainer>
                <Button
                  color="error"
                  startIcon={<DeleteIcon />}
                  variant="contained"
                  sx={{ mt: 1, mr: 1 }}
                  onClick={handelShowModal}
                >
                  حذف
                </Button>
                <Button
                  color="success"
                  startIcon={<CheckIcon />}
                  variant="contained"
                  sx={{ mt: 1, mr: 1 }}
                  onClick={handleSubmit(onSubmit)}
                >
                  ذخیره
                </Button>
              </ButtonContainer>
            </Grid>
          </StyledStack>
          <DeleteModal
            show={showDeleteModal}
            onClose={handelShowModal}
            onDelete={handelDelete}
          />
        </Grid>
      )}
    </DrawerCM>
  );
}
